import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon-sub-add.png'


const _withScopeId = n => (_pushScopeId("data-v-cc1ef13e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "params-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "params-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))

import { ref } from 'vue'
import { ACTIONS_CALL_TYPE, varReg } from '@/common'
import ParameterAll from './parameter-all-drawer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'actions-form',
  setup(__props, { expose: __expose }) {

const formRef = ref()

const validatorCode = (rule: any, value: any, callback: any) => {
  if (varReg.test(value)) {
    callback()
  } else {
    callback('字母、下划线、数字组合，且数字不能开头')
  }
}

const validatorProperties = (rule: any, value: any, callback: any) => {
  const codeList = (value || []).map(({ code }: any) => {
    return code
  })
  if ([...new Set(codeList)].length !== (value || []).length) {
    callback('参数名不能相同')
  } else {
    callback()
  }
}

const rules: any = {
  name: [{ required: true, message: '请输入' }],
  code: [
    { required: true, message: '请输入' },
    {
      validator: validatorCode,
    },
  ],
  callCode: [{ required: true, message: '请输入' }],
  inputParam: [
    // { required: true, message: '请选择', type: 'array' },
    {
      validator: validatorProperties,
    },
  ],
  outputParam: [
    {
      validator: validatorProperties,
    },
  ],
}

const formData: any = ref({
  name: '',
  code: '',
  callCode: ACTIONS_CALL_TYPE.SYN,
  desc: '',
  inputParam: [],
  outputParam: [],
})

const initForm = (data: any) => {
  formData.value = {
    ...formData.value,
    ...data,
  }
}

const removeParameter = (index: number, key: string) => {
  formData.value[key] = formData.value[key].filter(
    (item: any, i: number) => i !== index
  )
}

const onParameterSuccess = (data: any) => {
  const { index, key } = parameterConf.value
  if (index === -1) {
    formData.value[key].push(data)
  } else {
    formData.value[key][index] = data
  }
  formRef.value.validateField(key)
}

const parameterConf = ref({
  visible: false,
  data: {},
  index: -1,
  key: '',
})

const parameterForm = (data: any, index: number, key: string) => {
  parameterConf.value = {
    visible: true,
    data,
    index,
    key,
  }
}

const submit = async () => {
  return new Promise((resolve: any) => {
    formRef.value.validate((valid: boolean) => {
      if (valid) {
        resolve({
          ...formData.value,
        })
      }
    })
  })
}

__expose({
  submit,
  initForm,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: formData.value,
      rules: rules,
      class: "form ws_common_form",
      "label-width": 80
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "功能名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
              clearable: "",
              maxlength: "50",
              placeholder: "请输入功能名称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "标识符",
          prop: "code"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.code) = $event)),
              clearable: "",
              maxlength: "50",
              placeholder: "请输入标识符"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "调用方式",
          prop: "callCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: formData.value.callCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.callCode) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: _unref(ACTIONS_CALL_TYPE).SYN
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("同步")
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_radio, {
                  label: _unref(ACTIONS_CALL_TYPE).ASYN
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("异步")
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "输入参数",
          prop: "inputParam"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.inputParam, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "params-item",
                  key: index
                }, [
                  _createElementVNode("span", null, "参数名：" + _toDisplayString(item.code), 1),
                  _createElementVNode("span", null, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (parameterForm(item, index, 'inputParam'))
                    }, "编辑", 8, _hoisted_2),
                    _createElementVNode("a", {
                      onClick: ($event: any) => (removeParameter(index, 'inputParam'))
                    }, "删除", 8, _hoisted_3)
                  ])
                ]))
              }), 128))
            ]),
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (parameterForm({}, -1, 'inputParam'))),
              type: "text"
            }, {
              icon: _withCtx(() => [
                _hoisted_4
              ]),
              default: _withCtx(() => [
                _createTextVNode(" 增加参数 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "输出参数",
          prop: "outputParam"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.outputParam, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "params-item",
                  key: index
                }, [
                  _createElementVNode("span", null, "参数名：" + _toDisplayString(item.code), 1),
                  _createElementVNode("span", null, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (parameterForm(item, index, 'outputParam'))
                    }, "编辑", 8, _hoisted_6),
                    _createElementVNode("a", {
                      onClick: ($event: any) => (removeParameter(index, 'outputParam'))
                    }, "删除", 8, _hoisted_7)
                  ])
                ]))
              }), 128))
            ]),
            _createVNode(_component_el_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (parameterForm({}, -1, 'outputParam'))),
              type: "text"
            }, {
              icon: _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx(() => [
                _createTextVNode(" 增加参数 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "备注",
          prop: "desc"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.value.desc,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.desc) = $event)),
              type: "textarea",
              rows: 3,
              maxlength: "50",
              placeholder: "请输入备注"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(ParameterAll, {
      visible: parameterConf.value.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((parameterConf.value.visible) = $event)),
      data: parameterConf.value.data,
      onOnSuccess: onParameterSuccess
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})